import { call, put, takeEvery } from "redux-saga/effects"

import {

  GET_USER_STATUS_DEFINITIONS,

} from "./actionTypes"

import {

  getUserStatusDefinitionsSuccess,
  userStatusDefinitionsApiError

} from "./actions"

import {
  getUserStatusDefinitions,

} from "../../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* fetchUserStatusDefinitions() {
  try {
    const response = yield call(getUserStatusDefinitions)
    yield put(getUserStatusDefinitionsSuccess(response))
  } catch (error) {
    yield put(userStatusDefinitionsApiError(error))
  }
}


function* userStatusSaga() {
  yield takeEvery(GET_USER_STATUS_DEFINITIONS,fetchUserStatusDefinitions)
}

export default userStatusSaga